import './base/';
import './utilities/is-touch';
import './utilities/responsive-images';
import './utilities/mega-menu';
import './utilities/nav-trigger';
import './utilities/header-nav';
import './utilities/magnificPopup';
import './utilities/store-locator-popup';
import './utilities/accordion-tabs';
import './utilities/accordion-mobile';
import './utilities/clear-field';
import './utilities/lazy-images';
import './cart/cart';
import './cart/cart-utils';
import './sliders/product-slider';
import './sliders/intro-slider';
import './product/ajax-actions';
import './product/quantity';
import './product/pdp-variant-select';
import './product/build-external-section';
import './product/product-zoom';
import './product/destini-trigger';
import './polyfills/object-fit';

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed